export enum CITY_TYPE {
  DEFAULT = 'default',
  OTHER = 'other',
  INTERNACIONAL = 'internacional',
}
